import type { LearningFilterKey } from './types';

export const DEFAULT_TAB_KEY = 'all';

export const LEARNING_FILTER_KEYS = {
    Rank: 'rank',
    LearningState: 'learningState',
} as const;

export const LEARNING_DROPDOWN_FILTER_KEYS = (Object.values(LEARNING_FILTER_KEYS) as LearningFilterKey[]).filter(
    (key) => key !== LEARNING_FILTER_KEYS.LearningState,
);
